'use client';

import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@ahafood/ui/components/avatar';
import { Button } from '@ahafood/ui/components/button';
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@ahafood/ui/components/card';
import { assetPrefix } from '@ahm/api-wrappers-core';
import { formatCurrency } from '@ahm/common-helpers';
import { XIcon } from 'lucide-react';
import type { MenuItem } from '@/types/item';

interface ItemHeaderProps {
  item: MenuItem;
  storeImageUrl?: string;
  onClose: () => void;
}

export function ItemHeader({ item, storeImageUrl, onClose }: ItemHeaderProps) {
  return (
    <Card className="overflow-hidden relative border-none rounded-none shadow-none">
      <Avatar className="h-64 w-full rounded-none flex-none relative">
        <Button
          size="icon"
          variant="secondary"
          className="[&_svg]:size-6 flex-none rounded-full absolute top-4 right-4 z-10"
          onClick={onClose}
          type="button"
        >
          <XIcon />
        </Button>
        <AvatarImage
          src={
            item.image_thumb_url ??
            storeImageUrl ??
            `${assetPrefix}/static/images/empty-store.webp`
          }
          alt={item.name}
          className="object-top object-cover"
        />
        <AvatarFallback className="rounded-none">{item.name}</AvatarFallback>
      </Avatar>
      <CardHeader className="p-4 w-full">
        <CardTitle className="flex flex-row items-start gap-2 justify-between text-xl">
          <h3 className="mr-auto">{item.name}</h3>
          {item.discount_config && (
            <span className="text-neutral-50 line-through text-xs font-normal mt-1.5">
              {formatCurrency(item.price)}
            </span>
          )}
          <h5>{formatCurrency(item.discounted_price ?? item.price)}</h5>
        </CardTitle>
        {item.description && (
          <CardDescription>{item.description}</CardDescription>
        )}
      </CardHeader>
    </Card>
  );
}
